import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const personalizedJourneyTypeEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-journey-type", jiraSpaEntry: "async-servicedesk-journey-type" */ './src/ui/PersonalizedJourneyTypePage'
			),
	),
	getPreloadProps: () => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
